<script setup lang="ts">
import Button from "~/components/dumb/Button.vue";
import Tooltip from "~/components/dumb/Tooltip.vue";
import { ButtonStyle } from "~/shared/enums";

defineProps<{
  insertTooltipText: string;
  replaceTooltipText: string;
}>();

const emit = defineEmits<{
  insert: [];
  replace: [];
}>();
</script>

<template>
  <div class="flex items-center justify-end gap-2">
    <Tooltip :text="insertTooltipText">
      <Button :btn-style="ButtonStyle.SECONDARY" text="Insert" @click="emit('insert')" />
    </Tooltip>
    <Tooltip :text="replaceTooltipText">
      <Button :btn-style="ButtonStyle.PRIMARY" text="Replace" class="!px-3 !py-1" @click="emit('replace')" />
    </Tooltip>
  </div>
</template>
